export default __webpack_public_path__ + "static/media/img-test.74ae1a9d.png";